import * as React from 'react';
import './index.scss';
// import { StageDefault } from '@/context.ts';
import { fetch, GuildItem, GetGuildRankRsp, RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/web/default.png';
import GroupDetail from '@hooks/web/public/groupDetail.tsx';
import None from '@hooks/web/public/none.tsx';
const { useEffect, useState, useContext } = React;
interface Props {
  iStage: number,
}
const GroupChamption: React.FC<Props> = props => {
  // const { iStage } = useContext(StageDefault);
  const [list, List] = useState<GuildItem[]>([]);
  const [lists, Lists] = useState<any>([]);
  useEffect(() => {
    fetch.getGuildRank(
      {
        iStage: props.iStage,
        iArea: 5,
        iRevive: 0,
      },
    )
      .then((rsp: GetGuildRankRsp) => {
        console.log('公会榜单', {
          iStage: props.iStage,
          iArea: 5,
          iRevive: 0,
        }, rsp);
        List(rsp.vRank.value.slice(0, 3));
        Lists(rsp.vRsp.value);
      })
  }, [])
  const [showToast, ShowToast] = useState<boolean>(false);
  const [groupName, GroupName] = useState<string>('');
  const [groupId, GroupId] = useState<number>(0);
  const [datas, Datas] = useState<any>(null);
  const close = () => {
    ShowToast(false);
    GroupName('');
    GroupId(0);
  }
  return (
    <div
      className='web-groupChamption'
    >
      <ul className='web-groupList1'>
        {
          list.length !== 0 ?
            (
              list.map((items: GuildItem, index: number) => (
                <li key={items.lCompanyId}>
                  <div className='list-top'>
                    <div className='rankNoCover'><div className={`no-${items.iRank > 5 ? 'n' : items.iRank}`}>{items.iRank > 5 ? items.iRank : ''}</div></div>
                    <div className={`avatar avatar-${items.iRank > 3 ? 'n' : items.iRank}`}>
                      <img
                        title={items.sCompanyName}
                        src={items.sCompanyLogoUrl}
                        onError={(event: any): void => {
                          event.target.onerror = null;
                          event.target.src = defaultAvatar;
                        }}
                        onClick={
                          () => {
                            ShowToast(true);
                            GroupName(items.sCompanyName);
                            GroupId(items.lCompanyId);
                            Datas(lists[items.iRank - 1]);
                          }
                        }
                      />
                    </div>
                    <div className='groupMsg'>
                      <h1
                        onClick={
                          () => {
                            ShowToast(true);
                            GroupName(items.sCompanyName);
                            GroupId(items.lCompanyId);
                            Datas(lists[items.iRank - 1]);
                          }
                        }
                      ><span>{items.sCompanyName}</span> <a>详情{'>'}</a></h1>
                      {items.sDesc !== '' && <p>{items.sDesc}</p>}
                    </div>
                    <div className='groupMember'>
                      <div className='singles'>
                      </div>
                      <p></p>
                    </div>
                    <div className='groupScore'>
                      <h1>{items.lScore}</h1>
                      <p>总星光</p>
                    </div>
                  </div>
                  <div className='list-bottom'>
                    <div className='bottom-title'>
                      <i></i>
                      <p>十大战将</p>
                    </div>
                    <div className='bottom-list'>
                      {
                        items.vRank.value.map((item: RankItem, index: number) => {
                          if (index > 9) return '';
                          return (
                            <div key={item.lUid} className='bottom-list-item'>
                              <div className='imgAvatar'>
                                <img
                                  title={item.sNickName}
                                  src={item.sLogoUrl}
                                  onError={(event: any): void => {
                                    event.target.onerror = null;
                                    event.target.src = defaultAvatar;
                                  }}
                                  onClick={(): void => {
                                    window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                                  }}
                                />
                                {
                                  item.tJump.iLive !== 0 && <i />
                                }
                              </div>
                              <p
                                onClick={(): void => {
                                  window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                                }}
                              >{item.sNickName}</p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </li>
              ))
            ) :
            (
              <None text='暂无金牌公会数据' />
            )
        }
      </ul>
      {
        showToast &&
        <GroupDetail
          close={close}
          groupName={groupName}
          groupId={groupId}
          iStage={props.iStage}
          iArea={5}
          data={datas}
        />
      }
    </div>
  )
}

export default GroupChamption;